import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { validatePermission } from 'actions/index';
import useQuery from 'hooks/useQuery';
import InfiniteScroll from 'v3/components/InfiniteScroll';
import ApplicationLayout from 'v3/layouts/Application';
import { useSnackbar } from 'v3/components/Snackbar';
import Text from 'v3/components/Text';
import Button from 'v3/components/Button';
import { cooperplaceApi } from 'services/api';
import Space from 'v3/components/Space';
import { VehicleBodiesCard } from './Card';
import { VehicleBodiesFilter } from './Filter';
import { usePermission } from 'hooks';

export function VehicleBodiesList() {
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const hasPermissionToCreate = validatePermission('CADASTRAR_CARROCERIA');

  const [loading, setLoading] = useState(false);
  const [allVehicleBodies, setAllVehicleBodies] = useState([]);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [qtdAdvancedFilters, setQtdAdvancedFilters] = useState(0);

  const [pagination, setPagination] = useState({
    last_page: 1,
    current_page: 1,
    total: 0,
  });

  const queryParams = useQuery();

  const handleClose = () => setShowAdvancedFilters(false);
  const handleShow = () => setShowAdvancedFilters(true);
  function handleTitleAdvancedFilters() {
    let title = 'Filtro avançado';
    if (qtdAdvancedFilters) {
      title += ` (${qtdAdvancedFilters})`;
    }
    return title;
  }

  usePermission('VISUALIZAR_CARROCERIA', {
    redirect: true,
  });

  async function fetchVehicleBodies(page = 1) {
    if (page === 1) {
      setLoading(true);
    }
    try {

      const response = await cooperplaceApi.get(
        `vehicleBodies?${queryParams}&page=${page}`
      );

      if (response?.data?.data) {
        const { data, meta } = response.data;
        setAllVehicleBodies(oldVehicleBodies => {
          if (page === 1) {
            return data;
          }
          return [...oldVehicleBodies, ...data];
        });
        setPagination(meta);
      } else {
        setAllVehicleBodies([]);
        setPagination({
          last_page: 1,
          current_page: 1,
          total: 0,
        });
      }
    } catch (error) {

      const message = error?.response?.data?.message || 'Não foi possível listar as carrocerias';

      snackbar.show(
        <Text>{message}</Text>,
        {
          type: 'error',
        }
      );

    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchVehicleBodies();
  }, []);

  function renderItem(item) {
    return <VehicleBodiesCard vehicleBody={item} key={item.id} />;
  }

  return (
    <ApplicationLayout
      title="Carrocerias"
      RightComponent={
        <Space x={'0.5rem'}>
          <Button variant="secondary" onClick={() => handleShow()}>
            <Text weight={500} color="dark" type="regular">
              {handleTitleAdvancedFilters()}
            </Text>
          </Button>
          {hasPermissionToCreate && (
            <>
              <Button
                variant="primary"
                onClick={() => {
                  navigate('/carrocerias/cadastrar');
                }}
                style={{ minHeight: 44 }}
              >
                <Text weight={500} color="white" type="regular">
                  Nova Carroceria
                </Text>
              </Button>
            </>
          )}
        </Space>
      }
    >
      <VehicleBodiesFilter
        handleClose={handleClose}
        setQtdAdvancedFilters={setQtdAdvancedFilters}
        showAdvancedFilters={showAdvancedFilters}
        fetchVehicleBodies={fetchVehicleBodies}
      />
      <InfiniteScroll
        data={allVehicleBodies}
        onEndReach={() => fetchVehicleBodies(pagination?.current_page + 1)}
        hasMore={pagination?.current_page < pagination?.last_page}
        scrollThreshold={0.7}
        renderItem={renderItem}
        loading={loading}
      />
    </ApplicationLayout>
  );
}
